import React, { PropTypes } from 'react'
import CenterRow from '../CenterRow'
import CTAButton from '../CTAButton'

function AppsAndService(props) {
	return (
		<div className="row center-xs">
			<div className="col-sm-6 col-xs-12">
				<CenterRow headline="Applications">
					Acoustic cleaners provide an effective solution to buildup and material flow problems within a wide range of industries.
					<br /><br />
					<CTAButton href="/applications/" mini={true} variation="secondary" label="Learn More" />
					<br /><br />
				</CenterRow>
			</div>
			<div className="col-sm-6 col-xs-12">
				<CenterRow headline="Projects">
					Our acoustic cleaners cover a wide range of applications. Check out these pictures of some of our installations.
					<br /><br />
					<CTAButton href="/projects/" mini={true} variation="secondary" label="Learn More" />
					<br /><br />
				</CenterRow>
			</div>
		</div>
	)
}

AppsAndService.propTypes = {

}

AppsAndService.defaultProps = {

}

export default AppsAndService



// WEBPACK FOOTER //
// ../components/AppsAndService/index.js